export default __webpack_public_path__ + "static/media/image7.3f38d25f.svg";